const scrollTop = (scrollY = 0) => {
    setTimeout(() => {
        document.querySelector('#pageScrollWrapper').scrollTop = scrollY
        window.scroll({ top: -0.1, left: 0, behavior: 'smooth' })
    }, 10)
}

export default scrollTop
